import { render, staticRenderFns } from "./TextareaGroup.vue?vue&type=template&id=4e2d3cae&scoped=true"
import script from "./TextareaGroup.vue?vue&type=script&lang=js"
export * from "./TextareaGroup.vue?vue&type=script&lang=js"
import style0 from "./TextareaGroup.vue?vue&type=style&index=0&id=4e2d3cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d3cae",
  null
  
)

export default component.exports